import React from 'react';
import { MainContainer, SelectContainer, Select, ErrorText } from './styles';

const { Option } = Select;

export default ({
    id,
    name,
    showSearch,
    style,
    placeholder,
    value,
    onChange,
    onBlur,
    onClear,
    error,
    data,
    disabled = false,
    defaultValue = ""
}) => {
    return (
        <MainContainer style={style}>
            <SelectContainer error={error}>
                <label>{placeholder}</label>
                <Select
                    id={id}
                    name={name}
                    showSearch={showSearch}
                    allowClear
                    bordered={false}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onClear={onClear}
                    optionFilterProp="children"
                    defaultValue={defaultValue}
                    defaultActiveFirstOption={false}
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                >
                    {data.map(({value, label}) => (<Option key={value} value={value}>{label}</Option>))}
                </Select>
            </SelectContainer>
            {error && <ErrorText>{error}</ErrorText>}
        </MainContainer>
    );
};